import React, { Component } from "react";
import { Button, FormGroup, Form, Checkbox, Modal, OverlayTrigger, Tooltip, Glyphicon, Row, Col, Image } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {ToastContainer, ToastStore} from 'react-toasts';
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import moment from 'moment';
import _ from 'underscore';
import UsersService from "../../services/users-service";
import DispatchService from '../../services/dispatches-service';
import UtilsService from "../../services/utils-service";
import Loading from "../../components/loading";

import './style.css';

//For Massive Forms. Has better control over text and stuff supposedly.
let pdfMake = require('pdfmake/build/pdfmake.js');
let vfs_fonts = require('pdfmake/build/vfs_fonts.js');
pdfMake.vfs = vfs_fonts.pdfMake.vfs;

class DispatchArchive extends Component {
  constructor(props) {
    super(props);
      const user = UsersService.sharedInstance.getStoredCredentials();
    this.state = {
      data:props.dispatches ? props.dispatches : [],
      search:'',
      selected:[],
      guilty_data:null,
      confirm_modal:false,
      showInfoModal: false,
      loginResponse: user.loginResponse,
    };

    this._isMounted = false;
  }

  componentDidMount(){
    this._isMounted = true;
  }

  componentWillUnmount(){
    this._isMounted = false;
  }

  componentWillReceiveProps(nextProps){
    const that = this;
    const {search,selected,dispatches} = nextProps;

    this.setState({
      search,
      selected,
      data:dispatches
    },() => {
      that.onSearchDispatch();
    });
  }

  onSearchDispatch = () =>{
    const {search} = this.state;

    this.refs.dispatch_table.handleSearch(search);
  }

  onSelectRow = (row,is_selected) =>{
    const that = this;
    const {selected} = this.state;

    if(is_selected){
      selected.push(row);

      this.setState({ selected },() => {
        if(that.props.onSelect){
          that.props.onSelect(selected);
        }
      });
    }else{
      for(let x = 0; x < (selected).length; x++){
        if(selected[x].id === row.id){
          selected.splice(x, 1);

          this.setState({ selected },() => {
            if(that.props.onSelect){
              that.props.onSelect(selected);
            }
          });
        }
      }
    }
  }

  onSelectAllRow = (is_selected,rows) =>{
    const that = this;

    if(is_selected){
      this.setState({ selected:rows },() => {
        if(that.props.onSelect){
          that.props.onSelect(rows);
        }
      });
    }else{
      this.setState({ selected:[] },() => {
        if(that.props.onSelect){
          that.props.onSelect([]);
        }
      });
    }
  }

  render(){
    const {selected,confirm_modal,data} = this.state;
    const select = {
      mode:'checkbox',
      onSelect:this.onSelectRow,
      onSelectAll:this.onSelectAllRow,
      selected:[],
    };

    if(selected.length){
      for(let x = 0; x < (selected).length; x++){
        const {id} = selected[x];

        (select.selected).push(id);
      }
    }

    const options={
      onRowClick: (row) => {
        this.setState({
          selectedItem: row,
          showInfoModal: true,
        });
      },
      hideSizePerPage: true,
      defaultSortName: 'date_added',
      defaultSortOrder: 'desc'
    }

    return(
      <React.Fragment>
        <div className='reports-main-content'>
          <div className='incidents-table'>
            <BootstrapTable
              hover
              pagination
              width='100%'
              data={this.props.dispatches}
              keyField='id'
              trClassName='usersRow'
              ref='dispatch_table'
              selectRow={select}
              options={options}
            >
              <TableHeaderColumn dataField='dispatch_number' width='10%' dataSort>Dispatch #</TableHeaderColumn>
              <TableHeaderColumn dataField='call_type' width='10%' dataSort>Call Type</TableHeaderColumn>
              <TableHeaderColumn dataField='facility_name' width='15%' dataSort>Facility</TableHeaderColumn>
              <TableHeaderColumn dataField='date_added' width='10%' dataSort dataFormat={this.renderTableDate}>Date</TableHeaderColumn>
              <TableHeaderColumn dataField='time_dispatch' width='10%' dataSort dataFormat={this.renderTableDispatchTime}>Dispatch Time</TableHeaderColumn>
              <TableHeaderColumn dataField='personnel_data' width='15%' dataSort dataFormat={this.renderDispatchedPersonnel}>Personnel Dispatched</TableHeaderColumn>
              <TableHeaderColumn dataField='status' width='10%' dataSort dataFormat={this.renderDispatchedStatus}>Status</TableHeaderColumn>
            </BootstrapTable>
          </div>
        </div>
      {this.renderPreviewModal()}
      {this.renderMergeModal()}
        <Modal
          size='sm'
				  show={confirm_modal}
          onExit={this.onHideConfirmModal}
        >
          <Modal.Header>
            <b style={{fontSize: 20}}>Confirm Deletion</b>
          </Modal.Header>
          <Modal.Body>
            <p>Are you sure to delete this dispatch?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.onHideConfirmModal}>No</Button>
            <Button bsStyle='danger' onClick={this.onConfirmDeleteDispatch}>Yes</Button>
          </Modal.Footer>
        </Modal>
          {this.renderConfirmMergeModal()}
          <Loading isShowing={this.state.isMergingDispatches} message={this.state.mergeMessage}/>
          <Image id={"csaLogo"} src={require('../../assets/csa_logo.png')} style={{display:"none"}} />

      </React.Fragment>

		)
  }

  onHideConfirmModal = () =>{
    this.setState({
      confirm_modal:false,
    });
  }

  renderTableDate = (cell,row) =>{
    const {date_added} = row;
    const date = moment(date_added,'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY');

    return date;
  }

  renderTableDispatchTime = (cell, row) => {
    const {personnel_data} = row;
    const personnel_info = personnel_data;//Array.isArray(personnel_data) ? personnel_data : JSON.parse(personnel_data);
    let time_dispatch = "";
    if (personnel_info.length){
      time_dispatch = personnel_info[0].time_dispatch;
    }
    return time_dispatch;
  }

  renderDispatchedPersonnel= (cell, row) => {
    const {personnel_data, first_name} = row;
    const personnel_info = JSON.parse(personnel_data);
    let personnel_name = "";
    if (personnel_info.length){
      // TO-DO:
      // There is no name being stored in the personnel JSON value.
      // personnel_name = personnel_info[0].user_id ? first_name : "Needs Dispatching";
      personnel_name = personnel_info[0].user_id ? personnel_info[0].name : "Needs Dispatching";
    }
    const className = personnel_name == "Needs Dispatching" ? "attention-label" : "";
    return (
      <span className={className}> {personnel_name}</span>
    );
  }

  renderDispatchedStatus = (cell, row) => {
    const {status} = row;
    const finalStatus = status ? status : "In Progress";
    const className = finalStatus == "In Progress" ? "dispatch-progress-label" : "dispatch-completed-label";
    return (
      <span className={className}> {finalStatus}</span>
    );
  }

  renderTableActions = (cell, row) =>{
    return (
      <div className='actions-div'>
        <Button className='btn-actions' onClick={(e)=> {e.stopPropagation();this.onEditDispatch(row)}}>
          <FontAwesomeIcon className='' icon='pencil-alt' />
        </Button>
        <Button className='btn-actions' onClick={(e)=> {e.stopPropagation();this.onDownloadDispatch(row)}}>
          <FontAwesomeIcon className='' icon='download' />
        </Button>
        <Button className='btn-actions' onClick={(e)=> {e.stopPropagation();this.onDeleteDispatch(row)}}>
          <FontAwesomeIcon className='' icon='trash-alt' />
        </Button>
      </div>
    );
  }

  onEditDispatch = (row) =>{
    this.props.openEditTab(row)
  }

  onDownloadDispatch(row){

      var styles = {
        title: {
          fontSize: 15,
          bold: true,
          alignment: 'center',
        },
        header: {
          fontSize: 16,
          alignment: 'center',
          color: '#785448'
        },
        normal: {
          fontSize: 12,
        },
        normalBold: {
          fontSize: 12,
          bold: true,
        },
        normalIndented: {
          fontSize: 12,
          leadingIndent: 15,
          color: '#785448'
        },
        normalCenteredBold: {
          fontSize: 12,
          alignment: 'center',
          bold: true,
          color: '#785448'
        },
        normalBoldAlignLeft: {
          fontSize: 12,
          alignment: 'left',
          bold: true,
        }
      };

      //TEST VALUES
      // row = {id: "56",
      //         dispatch_no: "GAT-X101",
      //         facility_location_id: "ZGMF-1000",
      //         location_description: "Location description here",
      //         personnel_data: "[{\"name\":\"individual name here\",\"type\":\"Witness\", \"narrative\":\"narrative here\"}]",
      //         external_agency_data: "[{\"type\":\"police\",\"time_dispatch\":\"xxxxx\", \"time_arrvied\":\"yyy\"}]",
      //         forms_data: " {\"test\"}",
      //         sub_user_id: "1263",
      //         date_added: "2019-03-22 10:41:04",
      //         other_form_data: "{}",
      //         incident_narrative: "Incident Narrative here, Narrative of incident, of the incident, this narrative is.",
      //         first_name: "Brian",
      //         last_name: "Wittman",
      //         User_Type: "Super",
      //         facility_name: "Dummy Facility Name",
      //         incident_type: "test",
      //         facility_id: null,
      //         location_name: "Dummy Data Location"
      //     };
      let personnel_data = UtilsService.sharedInstance.tryParseJSON(row.personnel_data) ? JSON.parse(row.personnel_data) : [];
      let external_agency_data = UtilsService.sharedInstance.tryParseJSON(row.external_agency_data) ? JSON.parse(row.external_agency_data) : [];
      let other_form_data = UtilsService.sharedInstance.tryParseJSON(row.other_form_data) ? JSON.parse(row.other_form_data) : [];
      let content = [{text: " ", style: 'normal'},
                      {text: row.dispatch_number ? "Dispatch No: " + row.dispatch_number : "Dispatch No: ---", style: ['title', {alignment: "left"}]},
                      {text: "Date: " + moment(row.date_added).format("MMM DD, YYYY h:mm A"), style: ['title', {alignment: "left"}]},
                      {text: " ", style: 'normal'},
                      {text: "Dispatch Information", style: ['title', {alignment: "left"}]},
                      {canvas: [{ type: 'line', x1: 0, y1: 5, x2: 500, y2: 5, lineWidth: 1 }]},
                      {text: " ", style: 'normal'},
                      {columns: [
                        {width: 200, text: "Call Type: ", style: 'normalBold'},
                        {width: 300, text: row && row.call_type ? row.call_type : "---" , style: 'normal'}
                      ]},
                      {columns: [
                        {width: 200, text: "Facility: ", style: 'normalBold'},
                        {width: 300, text: row && row.facility_name ? row.facility_name : "---" , style: 'normal'}
                      ]},
                      {columns: [
                        {width: 200, text: "Location: ", style: 'normalBold'},
                        {width: 300, text: row && row.location_name ? row.location_name : "---" , style: 'normal'}
                      ]},
                      {columns: [
                        {width: 200, text: "Location Description: ", style: 'normalBold'},
                        {width: 300, text: row && row.location_description ? row.location_description : "---" , style: 'normal'}
                      ]},
                      {columns: [
                        {width: 200, text: "Incident Narrative: ", style: 'normalBold'},
                        {width: 300, text: row && row.incident_narrative ? row.incident_narrative : "---" , style: 'normal'}
                      ]},


                      {text: " ", style: 'normal'},
                      {text: " ", style: 'normal'},
                      {text: "External Agencies", style: ['title', {alignment: "left"}]},
                      {canvas: [{ type: 'line', x1: 0, y1: 5, x2: 500, y2: 5, lineWidth: 1 }]},
                      this.renderPDFExternalAgency(external_agency_data),


                      {text: " ", style: 'normal'},
                      {text: " ", style: 'normal'},
                      {text: "Dispatched Personnel Details", style: ['title', {alignment: "left"}]},
                      {canvas: [{ type: 'line', x1: 0, y1: 5, x2: 500, y2: 5, lineWidth: 1 }]},
                      this.renderPDFExternalAgency(external_agency_data),


                      {text: " ", style: 'normal'},
                      {text: " ", style: 'normal'},
                      {text: "Dispatched Personnel Details", style: ['title', {alignment: "left"}]},
                      {canvas: [{ type: 'line', x1: 0, y1: 5, x2: 500, y2: 5, lineWidth: 1 }]},
                      this.renderPDFDispatchedPersonnel(personnel_data),
                      {text: " ", style: 'normal'},
                      {text: "Reporting Personnel Details", style: ['title', {alignment: "left"}]},
                      {canvas: [{ type: 'line', x1: 0, y1: 5, x2: 500, y2: 5, lineWidth: 1 }]},
                      {text: " ", style: 'normal'},
                      {columns: [
                        {width: 200, text: "Personnel Reporting Incident: ", style: 'normalBold'},
                        {width: 300, text: other_form_data && other_form_data.personnel_name ? other_form_data.personnel_name : "---" , style: 'normal'}
                      ]},
                      {columns: [
                        {width: 200, text: "Personnel Phone: ", style: 'normalBold'},
                        {width: 300, text: other_form_data && other_form_data.personnel_phone ? other_form_data.personnel_phone : "---" , style: 'normal'}
                      ]},
                      {columns: [
                        {width: 200, text: "Personnel Location: ", style: 'normalBold'},
                        {width: 300, text: row && row.location_name ? row.location_name : "---" , style: 'normal'}
                      ]},

                      {columns: [
                        {width: 200, text: "Additional Notes: ", style: 'normalBold'},
                        {width: 300, text: other_form_data && other_form_data.additional_notes ? other_form_data.additional_notes : "---" , style: 'normal'}
                      ]},

                    ]

      //generate image
      const imgToExport = document.getElementById('csaLogo');
      const canvas = document.createElement('canvas');
              canvas.width = imgToExport.width; 
              canvas.height = imgToExport.height; 
              canvas.getContext('2d').drawImage(imgToExport, 0, 0);
      const csa360LogoURL =canvas.toDataURL('image/png');

      var docDef = {
        header: (currentPage, pageCount, pageSize) => {
                  return [
                            {text: " "},
                            {
                              width: 160,
                              image: csa360LogoURL, style: {alignment: 'center'}
                            }
                          ]
                       },
                     content: content,
                     styles: styles,
                     pageMargins: [40, 150, 40, 20],
                   }

     pdfMake.createPdf(docDef).open();

  }

  onConfirmDeleteDispatch = () =>{
    const that = this;
    const {guilty_data} = this.state;

    if(guilty_data && guilty_data.id){
      const {id} = guilty_data;

      DispatchService.sharedInstance.delete(id)
        .then(() => {
          ToastStore.success('Successfully deleted dispatch!');

          that.setState({
            guilty_data:null,
            confirm_modal:false,
            showInfoModal:false
          },() => {
            if(that.props.getDispatches){
              that.props.getDispatches();
            }
          });
        }).catch(err => {
          console.error('Error',err);

          ToastStore.error('Error in deleting dispatch!');
        });
    }
  }

  onDeleteDispatch = (guilty_data) =>{
    this.setState({
      guilty_data,
      confirm_modal:true
    });
  }

  renderConfirmMergeModal = () =>{
    const {showConfirmMergeModal} = this.state;
    const {selected} = this.props;

    return (
      <Modal
        size='sm'
        show={showConfirmMergeModal}
      >
        <Modal.Header>
          <b style={{fontSize: 20}}>Confirm Merge</b>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to Merge?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => {this.setState({showConfirmMergeModal: false})}}>No</Button>
          <Button 
            bsStyle='danger' 
            onClick={() => {
              this.setState({showConfirmMergeModal: false}); 
              this.mergeItems(selected[0],selected[1])
          }}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }

  renderMergeModal() {
    let selectedDispatches = this.props.selected ? this.props.selected : [];
    let tooMany = (selectedDispatches.length > 2);

    let dispatch1 = selectedDispatches && selectedDispatches[0] ? selectedDispatches[0] : null;
    let dispatch2 = selectedDispatches && selectedDispatches[1] ? selectedDispatches[1] : null;

      return (<Modal style={{marginTop: "5%"}}
                dialogClassName={"mergeModal"}
                show={this.props.showMergeModal}
                onExit={()=>{}}>
              <Modal.Header>
                  <b style={{fontSize: 20}}>Archive Merge</b>
              </Modal.Header>
              <Modal.Body>
                  <div style={{textAlign: 'left'}}>
                  {tooMany ?
                            <Row style={{color: "red", textAlign: "center"}}>
                              More than 2 Dispatches selected!
                            </Row>
                        : null}
                  <Row>
                    <Col md={7}>
                      <Row>
                        <Col md={9}>
                          <div id="canvasWindow">
                              { (selectedDispatches && selectedDispatches.length > 0)
                                  ? this.renderDispatchInformation(dispatch1)
                                  : <Row style={{marginTop: "20%", textAlign: "center"}}>No Form Selected</Row>}
                          </div>
                        </Col>
                        <Col md={3} >
                          <Glyphicon
                              glyph="arrow-right"
                              style={{marginTop: "60%", marginLeft: "40%", fontSize: 30}}
                          />
                        </Col>
                      </Row>

                    </Col>
                    <Col md={5}>
                      <div id="canvasWindow">
                      { (selectedDispatches && selectedDispatches.length > 1)
                          ? this.renderDispatchInformation(dispatch2)
                          : <Row style={{marginTop: "20%", textAlign: "center"}}>No Second Form Selected</Row>}
                      </div>
                    </Col>
                  </Row>
                  </div>
              </Modal.Body>
              <Modal.Footer>
                  <Button onClick={()=>{this.props.setShowMergeModal(false)}}>Cancel</Button>
                  <Button disabled={!(selectedDispatches != null && selectedDispatches.length == 2) || tooMany} bsStyle="danger" onClick={()=>{this.setState({showConfirmMergeModal: true})}}>Merge</Button>
              </Modal.Footer>
          </Modal>);
    //}


  }

  renderPreviewModal = () => {

    if(this.state.selectedItem != null) {
      return (
          <Modal show={this.state.showInfoModal}>
              <Modal.Header>
                  <b style={{fontSize: 20}}>

                  <OverlayTrigger
                      placement="top"
                      delay={200}
                      overlay={
                              <Tooltip id="overlay-example"> Close </Tooltip>
                      }>
                      <Glyphicon
                          glyph="remove"
                          className="pull-right"
                          style={{cursor: "pointer", marginLeft: 10}}
                          onClick={()=>{
                              this.setState({showInfoModal: false});
                          }}
                      />
                  </OverlayTrigger>

                  <OverlayTrigger
                    placement='top'
                    delay={200}
                    overlay={
                      <Tooltip id='delete-dispatch-tooltip'>
                        Delete this dispatch
                      </Tooltip>
                  }>
                    <Glyphicon
                      glyph='trash'
                      className={'pull-right'}
                      onClick={()=>{
                        this.onDeleteDispatch(this.state.selectedItem)
                      }}
                      style={{ cursor:'pointer',marginLeft:10 }}
                    />
                  </OverlayTrigger>

                  <OverlayTrigger
                      placement="top"
                      delay={200}
                      overlay={<Tooltip id="overlay-example">
                                  Download this item
                              </Tooltip>}>
                  <Glyphicon glyph="download-alt"
                      className={"pull-right"}
                      onClick={()=>{
                              this.onDownloadDispatch(this.state.selectedItem)
                              //this.downloadArchivePDF();
                              }}
                      style={{ cursor: "pointer", marginLeft: 10}}/>
                  </OverlayTrigger>

                  <OverlayTrigger
                      placement="top"
                      delay={200}
                      overlay={
                              <Tooltip id="overlay-example">
                                  Edit this item
                              </Tooltip>
                          }>
                  <Glyphicon glyph="pencil"
                      className={"pull-right"}
                      onClick={()=>{

                              //this.editArchiveItem();
                              this.setState({showInfoModal: false});
                              this.props.openEditTab(this.state.selectedItem)
                          }}
                      style={{ cursor: "pointer", marginLeft: 10}}/>
                  </OverlayTrigger>

                  </b>
              </Modal.Header>
              <Modal.Body>
                  <div id="canvasWindow">
                    {this.renderDispatchInformation(this.state.selectedItem)}
                  </div>
              </Modal.Body>
          </Modal>
      )

      return null
    }

  }

  renderDispatchInformation(item){
    const dispatch = item ? item : this.state.selectedItem;
    const dispatchNumber = dispatch.dispatch_number;
    const callType = dispatch.call_type ? dispatch.call_type : "";
    const dispatchLocation = dispatch.location_name ? dispatch.location_name : "";
    const dispatchLocationDescription = dispatch.location_description;
    const dispatchIncidentNarrative = dispatch.incident_narrative;
    const dispatchTitle = callType + " Incident at " + dispatchLocation;
    const other_form_data = UtilsService.sharedInstance.tryParseJSON(dispatch.other_form_data) ? JSON.parse(dispatch.other_form_data) : [];
    const external_agency_data = UtilsService.sharedInstance.tryParseJSON(dispatch.external_agency_data) ? JSON.parse(dispatch.external_agency_data) : [];
    const forms_data = UtilsService.sharedInstance.tryParseJSON(dispatch.forms_data) ? JSON.parse(dispatch.forms_data) : [];

    let linkedDispatches= null;

    try{
        linkedDispatches = dispatch.other_form_data
                                    ? JSON.parse(dispatch.other_form_data).linked_files != null && JSON.parse(dispatch.other_form_data).linked_files.length > 0
                                    ? JSON.parse(dispatch.other_form_data).linked_files
                                    : []
                                : [];
    }
    catch(e){
        linkedDispatches = [];
    }



    // Get dispatch time:
    const personnelInfo = JSON.parse(dispatch.personnel_data);
    // Get dispatch date:
    const dispatchDate = moment(dispatch.date_added,'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY');

    return(
      <div className="incident-section">
          <Row>
            <Col md={7}>
              <h3 className="orange-title">{dispatchTitle}</h3>
            </Col>
            <Col md={4}>
              <h5 className="info-type">Dispatch No: <span className="info-data">{dispatch && dispatchNumber ?  dispatchNumber : "None"}</span></h5>
              <h5 className="info-type">Date: <span className="info-data">{dispatch && dispatchDate ?  dispatchDate : "None"}</span></h5>
            </Col>
          </Row>

          <div className="left-side-content">

              <h3 className="sub-title">Dispatch Information</h3>
              <hr className="line"/>

              <h5 className="info-type">Call Type: <span className="info-data">{callType}</span></h5>
              <h5 className="info-type">Facility: <span className="info-data">{dispatch && dispatch.facility_name ? dispatch.facility_name : "None"}</span></h5>
              <h5 className="info-type">Location: <span className="info-data">{dispatchLocation ? dispatchLocation : "None"}</span></h5>
              <h5 className="info-type">Detailed Location Description:</h5>
              <p className="paragraph info-data">{dispatchLocationDescription ? dispatchLocationDescription : "None"}</p>

              <h5 className="info-type">Incident Narrative:</h5>
              <p className="paragraph info-data">{dispatchIncidentNarrative ? dispatchIncidentNarrative : "None"}</p>

              {this.renderExternalAgency(external_agency_data)}
              {this.renderFormsSection(forms_data)}
              {this.renderLinkedDispatches(linkedDispatches)}
          </div>

          <div className="right-side-content">

            <h3 className="sub-title">Dispatched Personnel</h3>
            <hr className="line"/>

            <div id="dispatched-personnel-section">
              {
                personnelInfo.map((personnel, i)=>{
                  return (
                    <div className="personnel-box" key={personnel + "-" + i}>
                      <h5 className="info-type">Name: <span className="info-data">{personnel.name ? personnel.name : ""}</span></h5>
                      <h5 className="info-type">Dispatched Time: <span className="info-data">{ personnel.time_dispatch }</span></h5>
                      <h5 className="info-type">Arrival Time: <span className="info-data">{ personnel.time_arrived }</span></h5>
                    </div>
                  )
                })
              }

            </div>

            <h3 className="sub-title">Reporting Personnel Details</h3>
            <hr className="line"/>

            <h5 className="info-type">Name: <span className="info-data">{ other_form_data.personnel_name }</span></h5>
            <h5 className="info-type">Phone: <span className="info-data">{ other_form_data.personnel_phone }</span></h5>
            <h5 className="info-type">Notes: <span className="info-data">{ other_form_data.additional_notes }</span></h5>

          </div>
      </div>
    )
  }

  renderExternalAgency(data){
    let rows = [];
    var names = {
      "ambulance_department": "Ambulance",
      "fire_department": "Fire Department",
      "police_department": "Police Department",
    }

    if (data != null){
      Object.keys(data).map((external_agency_data)=>{
        rows.push(
          {
            "department": names[external_agency_data],
            "dispatched_time": data[external_agency_data].time_dispatch || "",
            "arrival_time": data[external_agency_data].time_arrived || "",
            "cleared_time": data[external_agency_data].time_cleared || "",
          }
        )
      })

      if (rows.length){
        return (
          <div id="dispatch-external-agency">
            <h3 className="sub-title">External Agency</h3>
            <hr className="line"/>
            {
              rows.map((agency, i)=>{
                return (
                  <div key={agency +"-"+i} className="dispatch-agency">
                    <h5 style={{fontWeight: 600}}>{agency.department}:</h5>
                    <h5>Dispatched Time: <span className="info-data">{agency.dispatched_time}</span></h5>
                    <h5>Arrival Time: <span className="info-data">{agency.arrival_time}</span></h5>
                    <h5>Cleared Time: <span className="info-data">{agency.cleared_time}</span></h5>
                  </div>
                )
              })
            }
          </div>
        )
      }
    }
  }

  renderFormsSection(data){

    if (data.length){
      return (
        <div id="dispatch-external-agency">
          <h3 className="sub-title">Forms Data</h3>
          <hr className="line"/>

          {
            data.map((form, i)=>{
              return (
                <div key={form +"-"+i} className="dispatch-agency">
                    <span className="info-data">{form.form_name}</span>
                </div>
              )
            })
          }
        </div>
      )
    }
  }

  renderLinkedDispatches(data){
    if (data.length){
      return (
        <div id="dispatch-external-agency">
          <h3 className="sub-title">Linked Files</h3>
          <hr className="line"/>

          {
            data.map((dispatch, i)=>{
              return <h5
                        key={dispatch.dispatch_number}
                        style={{cursor: "pointer"}}
                        onClick={()=>{

                          let dispatchToDisplay = _.find(this.props.dispatches, (d)=>{
                            return d.id === dispatch.id;
                          })
                          this.setState({
                            selectedItem: dispatchToDisplay ? dispatchToDisplay : dispatch
                          })
                        }}>
                        <span className="info-data">Dispatch #{dispatch.dispatch_number}</span>
                      </h5>
              })
          }

        </div>
      )
    }
  }

  renderPDFDispatchedPersonnel(data) {

    var rows = [];
    if(data != null) {
      data.map((external_agency_data)=>{
        rows.push([{columns: [
                  {width: 200, text: "Dispatched Personnel: ", style: 'normalBold'},
                  {width: 300, text: external_agency_data && external_agency_data.name ? external_agency_data.name : "---" , style: 'normal'}
                ]},
                {columns: [
                  {width: 200, text: "Dispatched Time: ", style: 'normalBold'},
                  {width: 300, text: external_agency_data && external_agency_data.time_dispatch ? external_agency_data.time_dispatch : "---" , style: 'normal'}
                ]},
                {columns: [
                  {width: 100, text: "Arrival Time: ", style: 'normalBold'},
                  {width: 100, text: external_agency_data && external_agency_data.time_arrived ? external_agency_data.time_arrived : "---" , style: 'normal'},
                  {width: 100, text: "Guard Status: ", style: 'normalBold'},
                  {width: 200, text: external_agency_data && external_agency_data.guard_status ? external_agency_data.guard_status : "---" , style: 'normal'},
                ]},
                {text: " ", style: 'normal'},]);
      })
    }
    return rows;
  }

  renderPDFExternalAgency(data) {
    var rows = [];
    var names = {
                  "ambulance_department": "Ambulance",
                  "fire_department": "Fire Department",
                  "police_department": "Police Department",
                }
    if(data != null) {
      Object.keys(data).map((external_agency_data)=>{
       rows.push([{columns: [
                 {width: 200, text: "Department: ", style: 'normalBold'},
                  {width: 300, text: names[external_agency_data] ? names[external_agency_data] : "---" , style: 'normal'}
                ]},
                {columns: [
                  {width: 200, text: "Dispatched Time: ", style: 'normalBold'},
                  {width: 300, text: data[external_agency_data] && data[external_agency_data].time_dispatch ? data[external_agency_data].time_dispatch : "---" , style: 'normal'}
                ]},
                {columns: [
                  {width: 200, text: "Arrival Time: ", style: 'normalBold'},
                  {width: 300, text: data[external_agency_data] && data[external_agency_data].time_arrived ? data[external_agency_data].time_arrived : "---" , style: 'normal'}
                ]},
                {columns: [
                  {width: 200, text: "Time Cleared: ", style: 'normalBold'},
                  {width: 300, text: data[external_agency_data] && data[external_agency_data].time_cleared ? data[external_agency_data].time_cleared : "---" , style: 'normal'}
                ]},
                {text: " ", style: 'normal'},]);
      })
    }
    return rows;
  }

  mergeItems = (prev, next) =>{
    const that = this;

    this.setState({ isMergingDispatches:true });

    /* start merge personnel_data */
    const next_personnel_data = UtilsService.sharedInstance.tryParseJSON(next.personnel_data) ? JSON.parse(next.personnel_data) : [];
    const prev_personnel_data = UtilsService.sharedInstance.tryParseJSON(prev.personnel_data) ? JSON.parse(prev.personnel_data) : [];

    for(let x = 0; x < (prev_personnel_data).length; x++){
      next_personnel_data.push(prev_personnel_data[x]);
    }
    /* end merge personnel_data */

    /* start of merge forms_data */
    const next_forms_data = UtilsService.sharedInstance.tryParseJSON(next.forms_data) ? JSON.parse(next.forms_data) : [];
    const prev_forms_data = UtilsService.sharedInstance.tryParseJSON(prev.forms_data) ? JSON.parse(prev.forms_data) : [];

    for(let x = 0; x < (prev_forms_data).length; x++){
      next_forms_data.push(prev_forms_data[x]);
    }
    /* end of merge forms_data */

    /* start of merge of other_form_data */
    const next_other_data = UtilsService.sharedInstance.tryParseJSON(next.other_form_data) ? JSON.parse(next.other_form_data) : {};
    const prev_other_data = UtilsService.sharedInstance.tryParseJSON(prev.other_form_data) ? JSON.parse(prev.other_form_data) : [];

    const keys = Object.keys(prev_other_data);
    const exceptions = ['linked_files'];

    for(let x = 0; x < (keys).length; x++){
      const key = keys[x];

      if(exceptions.indexOf(key) >= 0) continue;

      if(!next_other_data[key]){
        next_other_data[key] = prev_other_data[key];
      }
    }

    const next_linked_files = next_other_data.linked_files && (next_other_data.linked_files).length ? next_other_data.linked_files : [];
    const prev_linked_files = prev_other_data.linked_files && (prev_other_data.linked_files).length ? prev_other_data.linked_files : [];

    for(let x = 0; x < (prev_linked_files).length; x++){
      next_linked_files.push(prev_linked_files[x]);
    }

    delete next_other_data.forms_data;

    next_other_data.linked_files = next_linked_files;
    /* end of merge of other_form_data */

    const next_facility_id = next.facility_id ? parseInt(next.facility_id) : null;
    const prev_facility_id = prev.facility_id ? parseInt(prev.facility_id) : null;

    const next_call_id = next.call_type_id ? parseInt(next.call_type_id) : null;
    const prev_call_id = prev.call_type_id ? parseInt(prev.call_type_id) : null;

    const next_location_id = next.facility_location_id ? parseInt(next.facility_location_id) : null;
    const prev_location_id = prev.facility_location_id ? parseInt(prev.facility_location_id) : null;


    const param = {
      id: next.id,
      sub_user_id:this.state.loginResponse.data[0].recno,
      date_added: next.date_added || prev.date_added,
      facility_id: next_facility_id || prev_facility_id,
      call_type_id: next_call_id || prev_call_id,
      dispatch_number: next.dispatch_number || prev.dispatch_number,
      facility_location_id: next_location_id || prev_location_id,
      status: next.status || prev.status,
      location_description: next.location_description + (prev.location_description ? `, ${prev.location_description}` : ''),
      incident_narrative: next.incident_narrative + (prev.incident_narrative ? `, ${prev.incident_narrative}` : ''),
      external_agency_data: next.external_agency_data ? next.external_agency_data : prev.external_agency_data,
      /* stringify field */
      personnel_data: JSON.stringify(next_personnel_data),
      forms_data: JSON.stringify(next_forms_data),
      other_form_data: JSON.stringify(next_other_data),
    };

    this.setState({ mergeMessage: 'Merging dispatches...' });

    /* update as item 2 */
    DispatchService.sharedInstance.edit(param)
      .then(() => {
        ToastStore.success('Dispatch successfully merged!');

        that.props.setShowMergeModal(false);
        that.props.onSelect([]);

        // delete item 1
        DispatchService.sharedInstance.delete(prev.id)
            .then(() => {
              that.setState({
                isMergingDispatches: false,
                showMergeModal: false,
              });
              that.props.getDispatches();
            }).catch(err => {
              console.error('Error',err);

              ToastStore.error('Error during merge!');

              that.setState({
                  isMergingDispatches: false,
                  showMergeModal: false,
              });
              that.props.getDispatches();
            });
      }).catch(err => {
        console.error('Error',err);

        ToastStore.error('Dispatch saving failed.');

        that.setState({
          isMergingDispatches: false,
          showMergeModal: false,
        });
        that.props.getDispatches();
      });
  }
}
export default DispatchArchive;
